
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { QuestionBank } from "./QuestionBank";
import { Question } from "@/types/test";
import { useIsMobile } from "@/hooks/use-mobile";

interface QuestionBankDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onQuestionSelect: (question: Question) => void;
}

export const QuestionBankDialog = ({
  open,
  onOpenChange,
  onQuestionSelect,
}: QuestionBankDialogProps) => {
  const isMobile = useIsMobile();
  
  const handleSelectQuestion = (question: Question) => {
    console.log('Question selected in dialog:', question);
    onQuestionSelect(question);
    onOpenChange(false); // Close dialog when a question is selected
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        className="fixed left-[50%] top-[50%] z-50 grid translate-x-[-50%] translate-y-[-50%] gap-2 border shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-sm"
        style={{
          width: "90%",
          maxWidth: "1200px",
          height: "80vh",
          maxHeight: "800px"
        }}
      >
        <DialogHeader className="pb-0">
          <DialogTitle className="text-foreground text-xl">Question Bank</DialogTitle>
        </DialogHeader>
        
        <div className="h-full overflow-hidden">
          <QuestionBank onSelectQuestion={handleSelectQuestion} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
